// import { CommonModule } from '@angular/common';
// import { AfterViewInit, Component, OnInit } from '@angular/core';
// import { Router } from '@angular/router';

// @Component({
//   selector: 'app-clients-testimonal',
//   templateUrl: './clients-testimonal.component.html',
//   styleUrls: ['./clients-testimonal.component.scss'],
//   standalone: true,
//   imports: [CommonModule]
// })
// export class ClientsTestimonalComponent implements OnInit, AfterViewInit {
//   clientLogos = [
//     { src: '../../../assets/home/clients/Emids.svg', alt: 'Emids' },
//     { src: '../../../assets/home/clients/Innova.svg', alt: 'Innova' },
//     { src: '../../../assets/home/clients/LG.svg', alt: 'LG' },
//     { src: '../../../assets/home/clients/NFP.svg', alt: 'NFP' },
//     { src: '../../../assets/home/clients/Omnisite.svg', alt: 'Omnisite' }
//   ];

//   testimonials = [
//     {
//       name: 'Nouri Bakkali',
//       position: 'Chief Executive Officer at Diligencia',
//       avatar: '../../../assets/home/clients/nouri_bakkali.webp',
//       linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
//       text: 'I wanted to take a moment to thank you for the services your team has provided. I am really impressed by the quality of services I received from Kalpita Technologies (P) Ltd. You were right on schedule, charged reasonable prices, were professional and courteous in dealings, and delivered items well before time. It is rare to find a service provider with such professional consistency - You are a valued service provider to our business and I wouldn’t hesitate in recommending you to other companies.'
//     },
//   {
//       name: 'Avinash R. Setty',
//       position: 'CTO, Omnisite',
//       avatar: '../../../assets/home/clients/nouri_bakkali.webp',
//       linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
//       text: 'When I first heard about Kalpita through a friend, I wasn’t sure of the quality of work, being a small company. But the moment I started working with them, I realized that they are very determined and dedicated towards whatever they do. Their main strength is on .NET software projects, and they excel in it. When Omnisite was in desperate need of an embedded engineer, Kalpita went out of their way to hire one, even though they had no prior experience in the field, just to help us in the needy time. We are grateful to have this relationship with Kalpita. I 100% recommend Kalpita for your outsourcing needs. Thanks again Kalpita for all the great work and service provided'
//     },
//       {
//       name: 'Rajesh N.Krishnan',
//       position: 'CEO, Brightwave Systems LLC',
//       avatar: '../../../assets/home/clients/nouri_bakkali.webp',
//       linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
//       text: 'Having worked with Kalpita on multiple projects on multiple platforms, it always felt like an extended team rather than an external service provider. Like your win-win proposition. The biggest strength of this team has been striking a balance between high level design/planning and attention to details at the lowest level while executing, a rare combo. Every single time, the deliverables hit the servers on/before the proposed timeline with the highest quality. Needless to say, would strongly recommend Kalpita for any software service needs. Looking forward to collaborating again on future projects and extending our journey together. Thanks for everything.'
//     },
//       {
//       name: 'Karunamoorthy Karuppanan',
//       position: 'CEO, Infinijith Apps & Technologies PVT LTD',
//       avatar: '../../../assets/home/clients/nouri_bakkali.webp',
//       linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
//       text: 'It is a great journey with Kalpita Technologies for years. The Kalpita team is very professional. I always wonder how everyone in Kalpita is highly communicative. They are clear on their message and make sure they understand us well. Kalpita did its best professionally during tough times like covid. Outstanding technologies, the best execution methodologies, and effective team handling skills. I really admire on their grow together attitude, clear vision, great business model and giving their best efforts to achieve them. Wish Kalpita prosper exponentially in the coming years.'
//     },
//       {
//       name: 'Shrikanth Janagonda',
//       position: 'Director of Engineering, Nouveau Labs',
//       avatar: '../../../assets/home/clients/nouri_bakkali.webp',
//       linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
//       text: `We at Nouveau Labs were building next generation audio and video platform and were in need of people with right skillset and great attitude on App development. Kalpita Technologies helped us instantly for the same and the best part of the engagement was, they went beyond their limits and were very flexible to accommodate changing needs. Definitely Kalpita Technologies has strong belief in "Customer First". It's a great journey with Kalpita for more than a year and we wish them a great success ahead.`
//     }
//   ];

//   activeSlideIndex = 0; 

//   aValue = 0;
//   bValue = 0;
//   cValue = 0;
//   dValue = 0;
//   eValue = 0;
//   fValue = 0;

//   aMax = 30;
//   bMax = 7;
//   cMax = 130;
//   dMax = 70;
//   eMax = 111;
//   fMax = 38;

//   constructor(private router: Router) {}

//   ngOnInit(): void {
//     this.startCounter();
//   }

//   ngAfterViewInit(): void {
//     const carousel = document.getElementById('testimonial-slider');
//     if (carousel) {
//       carousel.addEventListener('slid.bs.carousel', (event: any) => {
//         this.activeSlideIndex = event.to;
//       });
//     }
//   }

//   startCounter(): void {
//     this.incrementValue('aValue', this.aMax);
//     this.incrementValue('bValue', this.bMax);
//     this.incrementValue('cValue', this.cMax);
//     this.incrementValue('dValue', this.dMax);
//     this.incrementValue('eValue', this.eMax);
//     this.incrementValue('fValue', this.fMax);
//   }

//   incrementValue(property: 'aValue' | 'bValue' | 'cValue' | 'dValue' | 'eValue' | 'fValue', max: number): void {
//     const interval = setInterval(() => {
//       if (this[property] < max) {
//         this[property]++;
//       } else {
//         clearInterval(interval);
//       }
//     }, 50);
//   }

//   redirectToAbout(): void {
//     this.router.navigate(['/about-us']);
//   }
// }



import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clients-testimonal',
  templateUrl: './clients-testimonal.component.html',
  styleUrls: ['./clients-testimonal.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ClientsTestimonalComponent implements OnInit, OnDestroy {

  @Input() hideHeading = false;

  clientLogos = [
    { src: '../../../assets/home/clients/Emids.svg', alt: 'Emids' },
    { src: '../../../assets/home/clients/Innova.svg', alt: 'Innova' },
    { src: '../../../assets/home/clients/LG.svg', alt: 'LG' },
    { src: '../../../assets/home/clients/nfp-aon.svg', alt: 'NFP' },
    { src: '../../../assets/home/clients/Omnisite.svg', alt: 'Omnisite' }
  ];

  testimonials = [
    {
      name: 'Nouri Bakkali',
      position: 'Chief Executive Officer at Diligencia',
      avatar: '../../../assets/home/clients/nouri.webp',
      linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
      text: "I wanted to take a moment to thank you for the services your team has provided. I am really impressed by the quality of services I received from Kalpita Technologies (P) Ltd. You were right on schedule, charged reasonable prices, were professional and courteous in dealings, and delivered items well before time. It is rare to find a service provider with such professional consistency - You are a valued service provider to our business and I wouldn't hesitate in recommending you to other companies."
    },
    {
      name: 'Avinash R. Setty',
      position: 'CTO, Omnisite',
      avatar: '../../../assets/home/clients/Avinash.webp',
      linkedinUrl: 'https://www.linkedin.com/in/avinash-setty-bb24a012/',
      text: "When I first heard about Kalpita through a friend, I wasn't sure of the quality of work, being a small company. But the moment I started working with them, I realized that they are very determined and dedicated towards whatever they do. Their main strength is on .NET software projects, and they excel in it. When Omnisite was in desperate need of an embedded engineer, Kalpita went out of their way to hire one, even though they had no prior experience in the field, just to help us in the needy time. We are grateful to have this relationship with Kalpita. I 100% recommend Kalpita for your outsourcing needs. Thanks again Kalpita for all the great work and service provided"
    },
    {
      name: 'Rajesh N.Krishnan',
      position: 'CEO, Brightwave Systems LLC',
      avatar: '../../../assets/home/clients/Rajesh.png',
      // linkedinUrl: 'https://www.linkedin.com/in/nouri-bakkali-513a812/',
      text: 'Having worked with Kalpita on multiple projects on multiple platforms, it always felt like an extended team rather than an external service provider. Like your win-win proposition. The biggest strength of this team has been striking a balance between high level design/planning and attention to details at the lowest level while executing, a rare combo. Every single time, the deliverables hit the servers on/before the proposed timeline with the highest quality. Needless to say, would strongly recommend Kalpita for any software service needs. Looking forward to collaborating again on future projects and extending our journey together. Thanks for everything.'
    },
    {
      name: 'Karunamoorthy Karuppanan',
      position: 'CEO, Infinijith Apps & Technologies PVT LTD',
      avatar: '../../../assets/home/clients/karunamoorthy.webp',
      linkedinUrl: 'https://www.linkedin.com/in/karunamoorthy-karuppanan-895a2227/',
      text: 'It is a great journey with Kalpita Technologies for years. The Kalpita team is very professional. I always wonder how everyone in Kalpita is highly communicative. They are clear on their message and make sure they understand us well. Kalpita did its best professionally during tough times like covid. Outstanding technologies, the best execution methodologies, and effective team handling skills. I really admire on their grow together attitude, clear vision, great business model and giving their best efforts to achieve them. Wish Kalpita prosper exponentially in the coming years.'
    },
    {
      name: 'Shrikant Janagonda',
      position: 'Director of Engineering, Nouveau Labs',
      avatar: '../../../assets/home/clients/shrikanth.png',
      linkedinUrl: 'https://www.linkedin.com/in/shrikant-janagonda-a28a4710/',
      text: `We at Nouveau Labs were building next generation audio and video platform and were in need of people with right skillset and great attitude on App development. Kalpita Technologies helped us instantly for the same and the best part of the engagement was, they went beyond their limits and were very flexible to accommodate changing needs. Definitely Kalpita Technologies has strong belief in "Customer First". It's a great journey with Kalpita for more than a year and we wish them a great success ahead.`
    },
    {
      name: 'Shanker Agarwal',
      position: 'Founder & CEO, Dataabsolute Technologies',
      avatar: '../../../assets/home/clients/shanker.webp',
      linkedinUrl: 'https://www.linkedin.com/in/shankeragarwal/',
      text: `Working with the Kalpita Technologies team was a great experience. They demonstrated excellent knowledge, dedication, and commitment to delivering our project on time with exceptional quality. The Vehicle Delivery System they built helped automate the entire delivery process, from dealer to customer, once a vehicle is booked online. What I appreciate most about Kalpita is their quality of work, timely delivery, and proactive response. Their team often goes the extra mile, even working over weekends to ensure deadlines are met. They’re truly awesome and always available when needed. 
             I would highly recommend Kalpita Technologies for any kind of technology development or customized software solution, no matter what the technology, Kalpita will make it work. Overall, we found the Kalpita team to be knowledgeable, dedicated, and committed, and we look forward to collaborating with them again.`
    },
    {
      name: 'Janakarathinam K.K',
      position: 'Co-Founder & Director, Qono Technologies Pvt Ltd',
      avatar: '../../../assets/home/clients/Janakarathinam.webp',
      linkedinUrl: 'https://www.linkedin.com/in/janakarathinam-k-k-86635a2b/',
      text: `Our collaboration with Kalpita Technologies was nothing short of exceptional. Their team brought a rare blend of technical excellence, accountability, and agility that truly elevated our projects. We were impressed by how seamlessly they integrated with our internal team, consistently delivering high-quality work, often ahead of schedule. 
             Their clarity in communication, responsiveness to change, and commitment to doing things right made the entire engagement smooth and efficient. What stood out most was their professionalism and strong sense of business ethics, which built lasting trust. Overall, we’re extremely satisfied with Kalpita Technologies and would gladly collaborate with them again for future initiatives.`
    },
  ];

  pauseAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  resumeAutoSlide(): void {
    // Don't restart if dragging
    if (!this.isDragging && !this.autoSlideInterval) {
      this.startAutoSlide();
    }
  }

  // Slider functionality variables (from suite-technologies)
  currentSlide = 0;
  isDragging = false;
  startPosition = 0;
  currentPosition = 0;
  transformValue = 0;
  private autoSlideInterval: any;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  // Auto slide functionality
  startAutoSlide(): void {
    if (this.autoSlideInterval) return;
    this.autoSlideInterval = setInterval(() => {
      if (!this.isDragging) {
        this.nextSlide();
      }
    }, 2000);
  }

  // Mouse event handlers
  onMouseDown(event: MouseEvent): void {
    this.isDragging = true;
    this.startPosition = event.clientX;
    this.currentPosition = this.startPosition;
    clearInterval(this.autoSlideInterval);
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.isDragging) return;
    this.currentPosition = event.clientX;
    this.transformValue = -this.currentSlide * 100 + ((this.currentPosition - this.startPosition) / window.innerWidth * 100);
  }

  onMouseUp(event: MouseEvent): void {
    if (!this.isDragging) return;
    this.isDragging = false;

    const movedBy = this.currentPosition - this.startPosition;
    if (movedBy < -100) {
      this.nextSlide();
    } else if (movedBy > 100) {
      this.prevSlide();
    }

    this.transformValue = -this.currentSlide * 100;
    this.startAutoSlide();
  }

  // Touch event handlers
  onTouchStart(event: TouchEvent): void {
    this.isDragging = true;
    this.startPosition = event.touches[0].clientX;
    this.currentPosition = this.startPosition;
    clearInterval(this.autoSlideInterval);
  }

  onTouchMove(event: TouchEvent): void {
    if (!this.isDragging) return;
    this.currentPosition = event.touches[0].clientX;
    this.transformValue = -this.currentSlide * 100 + ((this.currentPosition - this.startPosition) / window.innerWidth * 100);
  }

  onTouchEnd(event: TouchEvent): void {
    if (!this.isDragging) return;
    this.isDragging = false;

    const movedBy = this.currentPosition - this.startPosition;
    if (movedBy < -100) {
      this.nextSlide();
    } else if (movedBy > 100) {
      this.prevSlide();
    }

    this.transformValue = -this.currentSlide * 100;
    this.startAutoSlide();
  }

  // Slide navigation
  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.testimonials.length;
    this.transformValue = -this.currentSlide * 100;
  }

  prevSlide(): void {
    this.currentSlide = (this.currentSlide - 1 + this.testimonials.length) % this.testimonials.length;
    this.transformValue = -this.currentSlide * 100;
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.transformValue = -this.currentSlide * 100;
    clearInterval(this.autoSlideInterval);
    this.startAutoSlide();
  }

  redirectToAbout(): void {
    this.router.navigate(['/about-us']);
  }
}
